import type { KeyValueStorage } from './receiptPrinterStorage';

export const POS_DEVICE_ID_STORAGE_KEY = 'incashflow.posDeviceId';

function resolveStorage(backend?: KeyValueStorage | null): KeyValueStorage | null {
  if (backend !== undefined) return backend;
  if (typeof globalThis.localStorage === 'undefined') return null;
  return globalThis.localStorage;
}

function newDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `posdev_${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;
}

/** Stable POS device id — created once and kept across terminal resets. */
export function ensurePosDeviceId(backend?: KeyValueStorage | null): string {
  const storage = resolveStorage(backend);
  if (!storage) return newDeviceId();
  const existing = storage.getItem(POS_DEVICE_ID_STORAGE_KEY)?.trim();
  if (existing) return existing;
  const id = newDeviceId();
  storage.setItem(POS_DEVICE_ID_STORAGE_KEY, id);
  return id;
}

export function readPosDeviceId(backend?: KeyValueStorage | null): string | null {
  const storage = resolveStorage(backend);
  if (!storage) return null;
  return storage.getItem(POS_DEVICE_ID_STORAGE_KEY)?.trim() || null;
}
